import React, {Component} from 'react';
import {connect} from 'react-redux';
import {I18n} from "react-redux-i18n";
import WidgetForm from "../components/WidgetForm";
import WidgetChoosePanel from "../components/WidgetChoosePanel";
import {config} from "../../config";
import TabbedPanel from "../../shared/components/others/tabs/TabbedPanel";
import actions from '../actions';
import _ from "../../shared/utils/ObjectUtils";
import PropTypes from "prop-types";
import entityActions from "../../entities/actions";
import Validators from "../../shared/utils/Validators";
import WidgetUtils from "../utils/WidgetUtils";

class WidgetFormContainer extends Component {
    constructor(props) {
        super(props);

        const { widgetToEdit } = props;

        this.state = {
            widgetType: widgetToEdit? widgetToEdit.type : undefined,
            formHasErrors: false,
            alert: {
                show: false
            },
            formData: widgetToEdit ? Object.keys(widgetToEdit.configs).reduce(
                (acc, key) => ({
                    ...acc,
                    [key]: {
                        value: widgetToEdit.configs[key],
                        error: undefined,
                        required: true
                    }
                }),
                {}) : {},
        }
    }

    handleFieldChange = (id, value, afterFieldIsChanged = () => {}) => {
        let {formData} = this.state;
        this.setState({
            formData: {
                ...this.state.formData,
                [id]: {
                    ...this.state.formData[id],
                    value: value
                }
            }
        }, () => {
            if (formData[id] && _.has(formData[id], 'required')) {
               this.validateField(id, value);
            }
            afterFieldIsChanged();
        })
    };

    validateField = (key, value) => {
        let {formData} = this.state;
        let error = null;

        switch (key) {
            case WidgetUtils.WidgetConfigFieldType.URL:
                error = !Validators.isUrl(formData[key].value) ? I18n.t('users.errors.url') : undefined;
                break;
            default:
                if (formData[key] &&
                    !_.isNilOrEmpty(formData[key].error) &&
                    formData[key].required &&
                    !_.isNilOrEmpty(value)) {
                    error = null;
                } else if (formData[key] && formData[key].required &&
                    _.isNilOrEmpty(value)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                }
        }
        if (formData[key] && error !== formData[key].error) {
            formData[key].error = error;
            setTimeout(
                () => {
                    this.setState({
                        formData,
                        formHasErrors: !_.isNilOrEmpty(error)
                    });
                }
            ,10)
        }
    };

    handleOnFieldBlur = (key) => {
        this.validateField(key)
    };

    createNewWidget = () => {
        const {createWidget, hideModal, dashboardId} = this.props;
        let {widgetType, formData} = this.state;

        hideModal();

        createWidget(widgetType, formData, dashboardId);
    };

    editWidget = () => {
        const {editWidget, hideModal, widgetToEdit} = this.props;
        let {formData} = this.state;

        hideModal();

        editWidget(widgetToEdit, formData);
    };

    setWidgetType = (widgetType) => {
        this.setState({
            widgetType: widgetType,
        });
    };

    clearWidgetType = () => {
        this.setState({
            widgetType: null,
            formData: {},
        });
    };

    render() {
        const {widgetType, formData} = this.state;
        const {widgetToEdit} = this.props;

        if (widgetType) {
            return <WidgetForm
                widgetType={widgetType}
                onEditMode={!!widgetToEdit}
                widgetToEdit={widgetToEdit}
                submitClicked={widgetToEdit ? this.editWidget : this.createNewWidget}
                backClicked={this.clearWidgetType}
                handleFieldChange={this.handleFieldChange}
                handleOnFieldBlur={this.handleOnFieldBlur}
                formData={formData}
            />;
        } else {
            const widgetCategories = config.widgetsGroups;

            let tabNames = [];
            let tabContents = [];

            widgetCategories.forEach(
                widgetCategory => {
                    tabNames.push(I18n.t("dashboard.widgets.categories." + widgetCategory.id));
                    tabContents.push(
                        <WidgetChoosePanel
                            widgetType={widgetType}
                            widgetsCategory={widgetCategory}
                            getWidgetForm={widgetType => this.setWidgetType(widgetType)}
                            backClicked={() => this.clearWidgetType()}
                            createClicked={newWidget => this.createNewWidget(newWidget)}
                        />
                    )
                }
            );

            return <TabbedPanel
                tabTitleTextAlignment="right"
                tabsLocation="left"
                tabTitles={tabNames}
                tabPanels={tabContents}
            />
        }
    }
}

const mapStateToProps = ({
    entitiesReducer,
    dashboardAndWidgetsReducer
}) => {
    const { dashboardReducer } = dashboardAndWidgetsReducer;
    return {
        entityList: entitiesReducer.entityList,
        dashboardId: dashboardReducer.dashboard.id
    };
};

const mapDispatchToProps = {
    createWidget: actions.createWidget,
    editWidget: actions.editWidget,
    getEntityList: entityActions.getEntityList,
};

WidgetFormContainer.propTypes = {
    widgetToEdit: PropTypes.object,
    hideModal: PropTypes.func,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WidgetFormContainer);
